export const selectMember = {
  title: '选择项目成员',
  loading: '加载中',
  cancel: '取消',
  ok: '确定'
}
